export const SAVE_USER_AUTH = 'SAVE_USER_AUTH'
export const LOAD_USER_AUTH = 'LOAD_USER_AUTH'
export const LOGOUT_USER_AUTH = 'LOGOUT_USER_AUTH'
